import React, { useState } from 'react'
import { ekincare_full_logo } from '../../assets/images'
import { LeftPanel } from '../common/templates/Login';
import OTP from '../common/templates/Login/OTP';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { appApi } from '../../services';
import { Spin, message } from 'antd';
import { loginPaths } from '../../constants/roleDetails';
import { handleAppError } from '../handlers';
import MFALogin from '../common/templates/Login/MFALogin';


function OTPPage(props) {
  const history = useHistory()
  const [isLoading, setLoading] = useState(false)
  const location = useLocation()
  let loginPage = location?.state?.username
  let mfa_type = sessionStorage.getItem('mfa_type')

  const requestAuth = async (code) => {
    let mfa_token = sessionStorage.getItem('mfa_token')
    let options = { data: {mfa_token: mfa_token, otp_code: code}}
    let mfa_enabled = JSON.parse(sessionStorage.getItem('mfa_enabled'))

    if(mfa_enabled){
      setLoading(true)
      let username = location?.state?.username
      let password = location?.state?.password

      let cal_http_https = window.API_URL.search('https') === -1 ? 'http' : 'https';
      let api_url = window.API_URL;
      let cal_url = api_url.replace('/v1/', '');

      const options = {
        data: {password: password,email:username, otp_code: code}
      }

      try {
        const response = await appApi.login(options);
          
          sessionStorage.clear()
          props.getLoginStatus(true)
          window.axios.defaults.headers.common['X-EKINCARE-KEY'] = response.headers['x-ekincare-key'];
          window.axios.defaults.headers.common['X-COMPANY-ID'] = response.data.company_id;
          sessionStorage.setItem('axiosHeaders', response.headers['x-ekincare-key']);
          sessionStorage.setItem('showPreEmp', response.data.enable_pre_emp);
          sessionStorage.setItem('hr_name', response.data.staff.name);
          sessionStorage.setItem('role', response.data.role);
          sessionStorage.setItem('companies', JSON.stringify(response.data.companies?.filter(e => e.id !== undefined && e.id !== null)));
          sessionStorage.setItem('company_id', response.data.company_id);
          sessionStorage.setItem('company_name', response.data.staff.company_name);
          sessionStorage.setItem('is_child_company', JSON.stringify(response.data.parent_company_id));
          sessionStorage.setItem('hr_email', response.data.staff.email);
          sessionStorage.setItem('launch_date', response.data.launch_date);
          sessionStorage.setItem('is_active', response.data.is_active);
          sessionStorage.setItem(
            'calendar_url',
            cal_url.replace(cal_http_https, 'webcal') + '/calendar/' + response.data.calendar_token + '/calendar.ics'
          );
          let is_active = sessionStorage.getItem('is_active');
          let role = sessionStorage.getItem('role');
          if(response.data.is_active === 'inactive' && role === 'staff'){
            sessionStorage.removeItem('mfa_token')
            setLoading(false)
            history.push('/mailer')
          }
          else{
            let sessionRole = sessionStorage.getItem('role')
            role = sessionRole ? sessionRole.toLowerCase().replace(/ /g, '_') : '/'
            sessionStorage.removeItem('mfa_token')
            setLoading(false)
            history.push(loginPaths[role])
          }
        }
        catch(error) {
          handleAppError(error)
          setLoading(false)
        }
      
    }
    else {
      setLoading(true)
      await appApi.mfaAuth(options,
        (res)=> {
            setLoading(false)
            let msg = res?.data?.message
            message.success(msg)
            history.push({pathname: '/mfa-backup-code', state: res.data})
        },
        (error)=>{
          handleAppError(error)
          setLoading(false)
        });
    }
  }

  const resendOtp = async () => {
    let username = sessionStorage.getItem('username')
    let options = { data: {email: username} }

    try {
      await appApi.mfaResendOTP(options, 
      (res) => {
        let msg = res?.data?.message
        message.success(msg)
      },
      (error) => {
        handleAppError(error)
      })
    } catch {
      handleAppError(error)
    }
  }

  const loader = () => {
    return (
      <div className="spiner">
        <Spin size="default" />
      </div>
    )
  }

    return (
      <>
          <div className='flex min-h-screen'>
            <LeftPanel />
            <div className='w-2/5 pt-16 pl-24 bg-white'>
              <img src={ekincare_full_logo} alt='ekincare_logo' />
              <div className='mt-12'>
              { isLoading ? loader() : (
                (mfa_type === 'authenticator_app') ? <MFALogin requestAuth={requestAuth} /> : 
                <OTP requestAuth={requestAuth} resend_otp={resendOtp} login_path={loginPage} />)}
            </div>
          </div>
        </div>
      </>
    )
}

export default OTPPage;